import { useSignal } from "@preact/signals-react";

import Board from "componentsv2/board/Board";
import layoutCalendar from "../models/ModelCalendar";
import { genStoreId } from "componentsv2/tools/functions";

const AvailableCalendar = ({ onChangeView }) => {
  const currentView = useSignal("list");
  const recordStoreId = useSignal(null);
  const _layoutCalendar = layoutCalendar;
  function handleView(action, recStoreId) {
    if (["edit", "add"].includes(action)) {
      currentView.value = "form";
      recordStoreId.value =
        recStoreId || genStoreId(_layoutCalendar.model, null);
    } else {
      currentView.value = "list";
      recordStoreId.value = null;
    }
    if (onChangeView) onChangeView(action);
  }

  return (
    <div className="flex flex-col items-center justify-center p-4 bg-slate-50 rounded-md overflow-auto">
      <Board
        layout={_layoutCalendar}
        currentView={currentView}
        recordStoreId={recordStoreId}
        handleView={handleView}
        setView={currentView}
      />
    </div>
  );
};

export default AvailableCalendar;
